import React from "react";

const ConversationList = ({ conversations, selectedConversation, onSelectConversation, formatDateTime }) => {
  return (
    <aside className="xl:col-span-4">
      <div className="flex h-[760px] flex-col overflow-hidden rounded-3xl border border-slate-800 bg-slate-900 shadow-sm">
        <div className="border-b border-slate-800 px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cyan-500/15 text-xl">💬</div>
            <div>
              <h2 className="text-lg font-semibold text-white">Conversations ouvertes</h2>
              <p className="text-sm text-slate-400">
                {conversations.length} ticket{conversations.length > 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          {conversations.length > 0 ? conversations.map((conversation) => {
            const isActive = selectedConversation?.id === conversation.id;
            const hasUnread = (conversation.unreadCount || 0) > 0;

            return (
              <button
                key={conversation.id}
                onClick={() => onSelectConversation(conversation)}
                className={`w-full border-b border-slate-800 px-5 py-4 text-left transition ${
                  isActive ? "bg-cyan-500/10 ring-1 ring-inset ring-cyan-500/20" : "hover:bg-slate-800/60"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <p className="truncate font-semibold text-slate-100">
                        {conversation.user?.firstname} {conversation.user?.lastname}
                      </p>
                      {hasUnread && (
                        <span className="inline-flex min-w-[24px] items-center justify-center rounded-full bg-red-500 px-2 py-0.5 text-[11px] font-bold text-white">
                          {conversation.unreadCount}
                        </span>
                      )}
                    </div>
                    <div className="mt-2 flex items-center gap-2">
                      {hasUnread && (
                        <span className="rounded-full bg-red-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-300">
                          Nouveau message
                        </span>
                      )}
                      {conversation.lastMessageAt && (
                        <p className="truncate text-xs text-slate-500">
                          {formatDateTime(conversation.lastMessageAt)}
                        </p>
                      )}
                    </div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold ${
                    conversation.status === "open"
                      ? "bg-emerald-500/10 text-emerald-300"
                      : "bg-slate-700 text-slate-300"
                  }`}>
                    {conversation.status === "open" ? "Ouverte" : "Fermée"}
                  </span>
                </div>
              </button>
            );
          }) : (
            <div className="px-5 py-8 text-sm text-slate-400">Aucune conversation trouvée.</div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default ConversationList;